import axios from 'axios';

const { VUE_APP_BASE_URL } = process.env;

export const fetchRecentActivity = projectId => axios({
  url: `/projects/${projectId}/social/activities/personal`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`
});

export const fetchMyFeed = (projectId, params) => axios({
  url: `/projects/${projectId}/social/personal`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
  params
});

export const fetchMyFeedVisit = (projectId, visitID) => axios({
  url: `/projects/${projectId}/social/${visitID}`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`
});

export const fetchTopScores = (projectId, params) => axios({
  url: `/projects/${projectId}/social`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
  params
});

export default {
  fetchRecentActivity,
  fetchMyFeed,
  fetchMyFeedVisit,
  fetchTopScores
};
